import React, { HTMLProps, useContext } from 'react';
import { GoogleIcon, MicrosoftIcon, IconButton } from '@design-system';
import { WLContext } from '@contexts';
import cn from 'classnames';

export interface IAuthButtonGroupProps
  extends Omit<HTMLProps<HTMLDivElement>, 'onClick'> {
  /**
   * Custom CSS tailwind styles.
   */
  className?: string;
  /**
   * If `true`, the buttons will have a disable state.
   */
  isDisabled?: boolean;
  /**
   * On click handler that will trigger the auth0 authentication.
   * @param {string} conn - authentication connection method.
   */
  onClick: (conn: 'google-oauth2' | 'windowslive') => void;
  /**
   * Element role.
   */
  role?: string;
}

export const AuthButtonGroup: React.FC<IAuthButtonGroupProps> = (
  props,
): JSX.Element => {
  const {
    className,
    isDisabled = false,
    onClick,
    role = 'group',
    ...rest
  } = props;
  const { color } = useContext(WLContext);

  return (
    <div
      className={cn('flex flex-row items-center justify-center gap-4', className)}
      role={role}
      {...rest}
    >
      <IconButton
        color="#F3F4F6"
        icon={<MicrosoftIcon height={20} style={{ color }} width={20} />}
        isDisabled={isDisabled}
        onClick={() => onClick('windowslive')}
        variant="solid"
        size="md"
        className="hover:scale-105 active:scale-95 transition-transform"
      />

      <IconButton
        color="#F3F4F6"
        icon={<GoogleIcon height={20} style={{ color }} width={20} />}
        isDisabled={isDisabled}
        onClick={() => onClick('google-oauth2')}
        variant="solid"
        size="md"
        className="hover:scale-105 active:scale-95 transition-transform"
      />
    </div>
  );
};

